import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M11.7 10a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0m0-6a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0m0 12a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0" />
  </svg>
);
export default SvgMore;
